import { DashboardModuleListItem } from '@domain-group/suit-theme'

import type { QuickLink } from '@modals/ManageEntityQuickLinksModal/hooks/useManageEntityQuickLinksModal'

interface QuickLinkListItemProps {
  quickLink: QuickLink,
}

const QuickLinkListItem = (props: QuickLinkListItemProps) => {
  const { quickLink } = props

  return (
    <DashboardModuleListItem
      onClick={() => window.open(quickLink.href, '_blank')}
      title={quickLink?.title}
    />
  )
}

export default QuickLinkListItem
